module.exports = __webpack_public_path__ + "static/media/WebLightMode.8a3effec.png";